import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';

/**
 * POST  filemanager/api/files/upload
 * @param {Object} data File upload data
 * @returns {Promise} uploaded file with file data
 */

export function uploadFile(formData, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.post(`filemanager/api/v3/files/upload`, {
    data: formData,
    headers: {
      'content-type': false
    }
  });
}

/**
 * GET  filemanager/api/v3/files/{fontId}
 */

export function fetchFile(id, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`filemanager/api/v3/files/${id}`);
}